/**
 * Call to dynamically create a evo contact form. Must be called before document ready.
 * @param {string} selector Selector in which the form will be appended to.
 * @param {string} sendToEmail Email address the form will be sent to.
 * @param {string} formstructure https://docs.evolutionx.io/en/articles/3436146-custom-contact-forms
 */
const insertCustomForm = (selector, sendToEmail, formstructure) => {
  const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  const evoxeval = btoa(sendToEmail);
  const gcaptcha = document.querySelector('meta[name*=gr-sitekey]').getAttribute('content');

  const captcha = document.createElement('script');
  captcha.src = 'https://www.google.com/recaptcha/api.js';
  document.querySelector('body').append(captcha);

  document.querySelector(selector).insertAdjacentHTML('beforeend', /* html */ `
    <form class="contact-form pdp-form">
      <input type="hidden" name="_token" value="${token}">
      <input type="hidden" name="evoxeval" value="${evoxeval}">
      <input type="hidden" name="type" value="1">
      
      ${formstructure}
      <div class="g-recaptcha" data-sitekey="${gcaptcha}"></div><br>
      
      <div class="response-message alert hide"></div>
    </form>
  `);
};

export default insertCustomForm;

// Example
// insertCustomForm('body', 'jgray+test@ecisolutions.com', /* html */ `
//   <div class="form-group">
//     <label for="name">Email</label>
//     <input type="email" name="email" value="" class="form-control" required>
//   </div>
//   <div class="form-group">
//     <label for="name">Message</label>
//     <textarea name="message" rows="5" class="form-control" required></textarea>
//   </div>
//   <div class="form-group">
//     <button type="submit" class="btn btn-primary btn-block">Send</button>
//   </div>
// `);